const Button = ({ children, variant = 'primary', onClick, className = '', href }) => {
  const baseClass = 'button'
  const variantClass = `button--${variant}`
  
  const handleClick = (e) => {
    if (onClick) {
      onClick(e)
    }
  }
  
  return (
    <button 
      onClick={handleClick}
      className={`${baseClass} ${variantClass} ${className}`}
    >
      {children}
    </button>
  )
}

export default Button 